import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Spinner = ({ className, size }) => (
  <div
    className={classnames('c-loader__spin', { 'c-loader__spin--small': size === 'small' }, className)}
    data-automation-id="icon:loading"
  />
);

Spinner.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
};
Spinner.defaultProps = {
  className: '',
  size: '',
};

export default Spinner;
